import { request } from '@/utils/request'
import { packCriteria } from '@/utils/filters'

export async function searchCompanies(criteria, limit = -1, offset = 0) {
    const { content } = await request.post('/api/companies/search', {
        criteria: packCriteria(criteria),
        limit,
        offset,
    })
    return content
}

export async function listCompanies() {
    const { results } = await searchCompanies([], -1, 0)
    return results
}

export async function getCompany(id, track) {
    const params = {
        track,
    }
    return request.get(`/api/companies/${id}`, params)
}

export async function getCompanySummary(id) {
    return request.get(`/api/companies/${id}/summary`)
}

export async function listCompanyFacets() {
    const content = await searchCompanies([], 0, 0)
    return content.facets
}

export default {
    list: listCompanies,
    get: getCompany,
    getSummary: getCompanySummary,
    listFacets: listCompanyFacets,
    search: searchCompanies,
}
